import { render, staticRenderFns } from "./AthleteComparativeDataMyProgress.vue?vue&type=template&id=71329f3a&scoped=true&"
import script from "./AthleteComparativeDataMyProgress.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataMyProgress.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataMyProgress.vue?vue&type=style&index=0&id=71329f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71329f3a",
  null
  
)

export default component.exports